<template>
  <span class="dialog-list-container">
    <v-list
      subheader
      dark
      class="dialog-list-container"
    >
      <v-list-tile>
        <router-link
          :to="{name: 'VisitsPage'}"
          @click.native="$emit('close')"
        >
          <HeaderButton :button-text="$t('header.planVisit')" />
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link
          :to="{name: 'ProfilePage'}"
          @click.native="$emit('close')"
        >
          <HeaderButton :button-text="$t('header.profile')" />
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <router-link
          :to="{name: 'PetsPage'}"
          @click.native="$emit('close')"
        >
          <HeaderButton :button-text="$t('header.pets')" />
        </router-link>
      </v-list-tile>
      <v-list-tile>
        <HeaderButton
          :button-text="$t('header.logout')"
          @click="$emit('logout')"
          @native="$emit('close')"
        />
      </v-list-tile>
    </v-list>
  </span>
</template>
<script>
import HeaderButton from './HeaderButton'

export default {
  name: 'DialogNavigation',
  components: {
    HeaderButton,
  },
}
</script>

<style scoped>
.dialog-list-container {
    margin-top: 40px;
}

.v-list >>> .v-btn__content {
  font-weight: bold;
  font-size: 16px;
}

a {
  text-decoration: none;
}

a.router-link-active >>> .v-btn__content {
  color: var(--v-primary-base);
}

.dialog-list-container  >>> .theme--dark.v-list {
    background:  var(--v-background-base);
}

a >>> .v-btn:hover {
   background-color: var(--v-background-base);
}

.dialog-list-container  >>> .v-list__tile {
    height: 40px;
}

.dialog-list-container >>> .v-ripple__container {
  opacity: 0;
}
</style>
